<template>
    <li :class="className"
        style="-moz-user-select: none; -webkit-user-select: none; -ms-user-select:none; user-select:none;-o-user-select:none;"
        unselectable="on"
        onselectstart="return false;"

        :draggable="status!==2"
        @dragstart="dragStart"
        @dragend.prevent="dragEnd"
        @dragover.prevent="dragOver"
        @dragleave.prevent="dragLeave"
        @drop.prevent="dropped">
        {{text}}
    </li>
</template>

<script>
    export default {
        mounted() {
            let vm = this;
            this.setInitialData();

            prolitEvents.$on('DroppedTask', ev => {
                if (vm.statementVariable === ev.element) {
                    vm.value = ev.value;
                    vm.status = 2;
                }
            });
            prolitEvents.$on('QuestionReset', ev => {
                if (vm.statementVariable === ev) {
                    vm.value = 0;
                    vm.status = 0;
                }
            });

            prolitEvents.$on('RequestValues', ev => {
                prolitEvents.$emit('ResponseValue', {
                    statementVariable: vm.statementVariable,
                    value: vm.value,
                })
            });

            prolitEvents.$on('ShowNotAnswered', ev => {
                this.showNotAnswer = true;
            });

        },
        props: {
            index: {
                required: true,
            },
            questionData: {
                required: true,
            }
        },
        data() {
            return {
                letters: ['A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J'],
                letter: "",
                text: "",
                statementVariable: "",
                status: 0, //0 initial 1 dragging 2 dropped
                classNames: ['', 'selected', "dragged"],
                value: 0,
                showNotAnswer: false
            }
        },
        watch: {
            questionData: {
                deep: true,
                handler() {
                    this.setInitialData();
                    this.showNotAnswer = false;
                }
            }
        },
        computed: {
            className() {
                let notAnswered = (this.showNotAnswer && !this.value) ? " noAnswered" : "";
                return this.classNames[this.status] + notAnswered;
            },
            dataToTransfer() {
                return JSON.stringify({
                    letter: this.letter,
                    statementVariable: this.statementVariable,
                    text: this.text,
                    dragFrom: 'questions',
                    value: this.value,
                });
            }
        },
        methods: {
            setInitialData() {
                let vm = this;
                this.letter = this.letters[this.index];
                this.text = this.questionData.label;
                this.statementVariable = this.questionData.code;
                if (this.questionData.user_answer !== null) {
                    // console.log(this.questionData.user_answer);
                    this.value = this.questionData.user_answer;
                    this.status = 2;
                    prolitEvents.$emit('AnswerFromDB', {
                        data: this.dataToTransfer,
                    });
                }else{
                    prolitEvents.$emit('QuestionReset', this.statementVariable);
                    this.status = 0;
                }

            },
            dragStart(ev) {
                this.status = 1; //dragging
                ev.dataTransfer.setData('text', this.dataToTransfer);
            },
            dragEnd(ev) {
                if (!this.value) {
                    this.status = 0;
                }
            },
            dragOver() {
            },
            dragLeave() {
            },
            dropped(ev) {
                let payload = JSON.parse(ev.dataTransfer.getData('text'));
                if (payload.dragFrom === "answers") {
                    prolitEvents.$emit('QuestionReset', payload.statementVariable);
                }
            }
        }
    }
</script>

<style>
    .noAnswered {
        border-color: #ee3126 !important;
    }

</style>



// WEBPACK FOOTER //
// resources/assets/js/views/assessments/skills/SkillsQuestions.vue